import clsx from 'clsx';
import { useExperiment } from '@hungryroot/experiments';
import { Paragraph } from '@hungryroot/ramen';

import styles from './FlexCreditCheckoutMessage.module.css';

export const YOU_PLAN_DESC =
  '*SmartCart™ adapts to you over time. If you regularly order more than your plan, it will adjust and recommend more personalized items for you, which may increase your weekly cost. You can always customize items out to return to your weekly plan price.';

interface FlexCreditCheckoutMessageProps {
  className?: string;
}

export function FlexCreditCheckoutMessage({
  className,
}: FlexCreditCheckoutMessageProps) {
  const flexCreditExp = useExperiment(164);

  if (flexCreditExp === 1) {
    return (
      <Paragraph
        variant="caption"
        className={clsx(styles.paragraph, className)}
      >
        {YOU_PLAN_DESC}
      </Paragraph>
    );
  }
  return null;
}
